import { render, staticRenderFns } from "./MyKombiDirectSaleCart.vue?vue&type=template&id=f2cc0cd0&"
import script from "./MyKombiDirectSaleCart.vue?vue&type=script&lang=js&"
export * from "./MyKombiDirectSaleCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports